import {
    curryN,
} from 'ramda'

export const maybeFilterBy = curryN(3, (filterFn, predFn, list) => predFn() ? list.filter(filterFn) : list)